<template>
    <div class="party-selection party-selection--collapsed">
        <div class="party-selection__content party-selection__content--selected">
            <VGrid>
                <div slot="gridItem" type="4" v-for="(party, i) in parties" :key="i">
                <div class="party-selection__item">
                    <h3 class="party-selection__content__header">
                    <span class="party-selection__content__header__number">
                        <span>{{ i+1 }}</span>
                    </span>
                    <span class="party-selection__content__header__name" data-hj-suppress>{{ party.title }}</span>
                    <UserCircleIcon
                      class="party-selection__content__header__icon"
                      height="25"
                      width="25"
                    />
                    </h3>
                    <h4 class="party-selection__content__sub-header" data-hj-suppress>{{ party.email }}</h4>
                </div>
                </div>
            </VGrid>
        </div>
    </div>
</template>

<script>
import VGrid from '@/components/deprecated/organisms/Grid.vue';
import { UserCircleIcon } from '@/components/icons/fontIcons';

export default {
  props: {
    parties: {
      type: Array,
      required: false,
    },
  },
  components: {
    VGrid,
    UserCircleIcon,
  },
};
</script>

<style scoped>
.party-selection--collapsed .party-selection__content {
  padding: 0;
  background: transparent;
  border: none;
}

.party-selection--collapsed .party-selection__content h4 {
  margin-bottom: var(--spacing-xs);
}

.party-selection--collapsed .party-selection__content span {
  word-break: break-word;
}

.party-selection--collapsed .party-selection__content__header {
  font-size: 25px;
}

.party-selection--collapsed .party-selection__content__header:after {
  content: '';
  display: block;
  clear: both;
}

.party-selection--collapsed .party-selection__content__header__number {
  padding: 11px 8px;
  float: left;
  background: var(--signable-secondary-1);
  font-size: 11px;
  border-radius: 30px;
  color: #fff;
  margin-right: var(--spacing-small);
  line-height: 0;
  font-weight: bold;
  width: 25px;
  height: 25px;
  position: relative;
}

.party-selection--collapsed .party-selection__content__header__number span {
  position: absolute;
  transform: translate3d(-50%, -50%, 0);
  top: 50%;
  left: 50%;
}

.party-selection--collapsed .party-selection__content__header__name {
  position: relative;
  z-index: 1;
  float: left;
  width: 85%;
  line-height: 25px;
}

.party-selection--collapsed .party-selection__content__header__icon {
  position: absolute;
  top: var(--spacing-small);
  right: var(--spacing-small);
  width: 20px;
  height: 20px;
  color: var(--signable-secondary-4-shade-2);
}

.party-selection--collapsed .party-selection__content__sub-header {
  color: var(--signable-secondary-3);
}

.party-selection--collapsed .party-selection__content .party-selection__item {
  background: #fff;
  border: 1px solid var(--color-border);
  padding: var(--spacing-base);
  border-radius: 9px;
  box-shadow: 0px 0px 5px -2px var(--color-border);
  position: relative;
}

.party-selection--collapsed .party-selection__merge-fields {
  margin-top: var(--spacing-small);
  padding-top: var(--spacing-small);
}

.party-selection--collapsed .party-selection__merge-fields .o-grid {
  margin-top: var(--spacing-xs);
}

.party-selection--collapsed .party-selection__buttons {
  border-top: 1px solid #000;
}

</style>
